import { useEffect, useState } from 'react';
import API from '../../api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import CustomerInfo from '../smallComponent/CustomerInfo';
import {API_IMAGE_URL} from '../../lib/api'
import { useCustomers } from '../context/CustomerContext';
import { Card } from 'react-bootstrap';
import CustomerFilterBar from '../smallComponent/CustomerFilterBar';
import * as XLSX from "xlsx";

export default function CompleteProject({ user }) {
  const [customers, setCustomers] = useState([]);


  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
   const { allCustomers, fetchCustomers } = useCustomers();
 

  

  useEffect(() => {
    let result = allCustomers || [];

    // search filter
    if (search) {
      result = result.filter((c) =>
        (c.customer_name || "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    // date filter
    if (startDate) {
      result = result.filter(
        (c) => new Date(c.done_date) >= new Date(startDate)
      );
    }
    if (endDate) {
      result = result.filter(
        (c) => new Date(c.done_date) <= new Date(endDate)
      );
    }

    // sirf active customers
    result = result.filter(
      (c) => c.status === 3
    );

    setCustomers(result);
    setCurrentPage(1);
  }, [allCustomers, search, startDate, endDate]);
  
    // 🔹 Reset
    const resetFilter = () => {
      setSearch("");
      setStartDate("");
      setEndDate("");
      setFilteredCustomers(allCustomers || []);
      setCurrentPage(1);
    };

  const showMessage = (msg, isError = false) => {
    if (isError) setError(msg);
    else setMessage(msg);
    setTimeout(() => {
      setMessage('');
      setError('');
    }, 3000);
  };








  const handlechangeStatus = async (id, newStatus) => {
    try {
      await API.post(`/customers/${id}/accept`, { status: newStatus });
      showMessage(`Project status updated to ${newStatus}`);
      fetchCustomers();
    } catch {
      showMessage('Failed to update project status', true);
    }
  };

  const exportToExcel = () => {
    const data = filteredCustomers.map((c, i) => ({
      SN: i + 1,
      Name: c.customer_name,
      Phone: c.contact_number,
      Business: c.business_name,
      StartDate: c.project_start_date,
      DoneDate: c.done_date,
      Developer: c.main_developer_name,
      Salesman: c.sales_representative_name,
      Price: c.price,
      Due: c.due_amount,
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");
    XLSX.writeFile(workbook, "CustomerList.xlsx");
  };



  return (
    <div className="container mx-auto py-4 px-2">
      <h2 className="mb-4 text-2xl font-semibold">✅ Complete Projects</h2>

      {message && (
        <div className="mb-4 rounded bg-green-100 border border-green-400 text-green-700 px-4 py-3" role="alert">
          {message}
        </div>
      )}
      {error && (
        <div className="mb-4 rounded bg-red-100 border border-red-400 text-red-700 px-4 py-3" role="alert">
          {error}
        </div>
      )}
      <Card className="mb-3 shadow-sm">
        <Card.Body>
          <CustomerFilterBar
            search={search}
            setSearch={setSearch}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            onExport={exportToExcel}
            onReset={resetFilter}
          />
        </Card.Body>
      </Card>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded table-fixed">
          <thead className="bg-gray-800 text-white text-sm">
            <tr>
              <th className="border border-gray-300 px-3 py-2 w-10">SN</th>
              <th className="border border-gray-300 px-3 py-2">Customer Info</th>
              <th className="border border-gray-300 px-3 py-2">Co-Developer</th>
              <th className="border border-gray-300 px-3 py-2">Work Details</th>
              <th className="border border-gray-300 px-3 py-2">Salesman/<br />Duration</th>
              <th className="border border-gray-300 px-3 py-2 w-24">Price</th>
              <th className="border border-gray-300 px-3 py-2">Work Process</th>
              <th className="border border-gray-300 px-3 py-2 w-48">Actions</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {customers.length > 0 ? customers.map((c, i) => (
              <tr key={c.id} className="even:bg-gray-50">
                <td className="border border-gray-300 px-3 py-2 text-center">{i + 1}</td>
                <td className="border border-gray-300 px-3 py-2">
                  <CustomerInfo customer={c} />
                </td>
<td className="border border-gray-300 px-3 py-2">
  {/* Developer name for Co-Developer */}
  {c.user_role === 'Co-Developer' && c.developer_name && (
    <div className="mb-1 text-sm font-semibold text-purple-700">
      <FontAwesomeIcon icon={faCheck} /> Developer: {c.developer_name}
    </div>
  )}

  {/* Codeveloper team */}
  {c.codeveloper_team.length > 0 ? (
    c.codeveloper_team.map((dev) => (
      <div key={dev.id}>
        <FontAwesomeIcon icon={faCheck} /> {dev.full_name}
      </div>
    ))
  ) : (
    <span className="text-gray-400 text-sm">None</span>
  )}
</td>

                <td className="border border-gray-300 px-3 py-2">
                  {c.work_details}<br />
                  {c.upload_quatation ? (
                    <a
                      href={`${API_IMAGE_URL}quotations/${c.upload_quatation}`}
                      className="inline-block mt-1 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      📄 Quotation
                    </a>
                  ) : (
                    <span className="text-gray-500 italic">No File</span>
                  )}
                </td>
                <td className="border border-gray-300 px-3 py-2">
                  👤 {c.salesman_name || <em className="text-gray-500 italic">Not Assigned</em>}<br />
                  ⏱️ {c.project_duration || <em className="text-gray-500 italic">N/A</em>} Days
                </td>
                <td className="border border-gray-300 px-3 py-2 text-center">
                  <strong className="text-green-600">₹{c.price}</strong><br />
                  <small className="text-red-600">Due: ₹{c.due_amount}</small>
                </td>
                <td className="border border-gray-300 px-3 py-2">
                  <div className="mb-2">
                    {c.work_process_details.length > 0 ? (
                      <ul className="list-disc pl-5 mb-2 max-h-24 overflow-y-auto">
                        {c.work_process_details.slice(-2).map((w, wi) => (
                          <li key={wi}><strong>{w.date || 'N/A'}:</strong> {w.text || w}</li>
                        ))}
                      </ul>
                    ) : (
                      <small className="text-gray-500 italic">No details yet</small>
                    )}
                    <div className="flex gap-2 mt-2">

                    </div>
                  </div>


                </td>
                <td className="border border-gray-300 px-3 py-2 text-center space-y-1">
<button
  onClick={() => handlechangeStatus(c.id, 2)}
  className={`px-3 me-1 py-1 rounded text-sm bg-blue-600 hover:bg-blue-700 text-white`}
>
  Back To Work
</button>


                  <div className="mt-1 flex justify-center gap-1">
                    <a
                      href={`tel:${c.contact_number}`}
                      className="px-2 py-1 bg-green-600 hover:bg-green-700 text-white rounded text-sm inline-flex items-center justify-center"
                      aria-label="Call customer"
                    >
                      <FontAwesomeIcon icon={faPhone} />
                    </a>
                    <a
                      href={`https://wa.me/${c.contact_number}`}
                      target="_blank"
                      rel="noreferrer"
                      className="px-2 py-1 bg-green-600 hover:bg-green-700 text-white rounded text-sm inline-flex items-center justify-center"
                      aria-label="WhatsApp customer"
                    >
                      <FontAwesomeIcon icon={faWhatsapp} />
                    </a>
                  </div>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-500">No customers found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>


    </div>
  );
}









